export const PageType = {
  DASHBOARD:        'dashboard',
  ORDERS:           'orders',
  ORDERS_DETAIL:    'orders-detail',
  PRODUCTS:         'products',
  PRODUCT_ADD:      'product-add',
  PRODUCT_EDIT:     'product-edit',
  PRODUCT_METADATA: 'product-metadata',
} as const;

export type PageType = (typeof PageType)[keyof typeof PageType];

export type NavParams = { type: PageType; id?: string; action?: string };

export function resolveNavRoute(params: NavParams): string | null {
  switch (params.type) {
    case PageType.DASHBOARD:
      return '/';
    case PageType.ORDERS:
      return '/orders';
    case PageType.ORDERS_DETAIL:
      return params.id ? `/orders?orderId=${encodeURIComponent(params.id)}` : '/orders';
    case PageType.PRODUCTS:
      return '/products';
    case PageType.PRODUCT_ADD:
      return '/products/add';
    case PageType.PRODUCT_EDIT:
      return params.id ? `/products/edit/${encodeURIComponent(params.id)}` : '/products';
    case PageType.PRODUCT_METADATA:
      return '/product-metadata';
    default:
      return null;
  }
}
